module.exports = __webpack_public_path__ + "static/cloud_expenses-3ad19a976d4cf6fb86443eb25be86c97.webp";